import React, {useEffect, useState} from "react";
import {X} from "react-feather";

// internal rebet imports
import "./stylesGlobalChatTogglePopup.css";

// component imports
import RebetLoader from "../../../../../CommonComponents/RebetLoader/RebetLoader";
import createPrivateAdminPanelInstance from "../../../../../../api/PrivateAdminPanelInstance";
import {API_ROUTES} from "../../../../../../api/ApiRoutes";

import {message} from "antd";
import ToggleSwitch from "../../../../../CommonComponents/ToggleSwitch/ToggleSwitch";
import {fetchSpecificUsersData} from "../../../../../../api/CommonFunctions/CommonFunctions";

const GlobalChatTogglePopup = ({isVisible, onClosePressed, userId, userData,}) => {
    // non-state variables
    const token = JSON.parse(localStorage.getItem("token"));
    const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(token?.IdToken, false);
    // state variables
    const [isApiRunning, setIsApiRunning] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [globalChatOption, setGlobalChatOption] = useState([]);

    const handleToggleGlobalChatChange = async (updatedFlag) => {
        const updatedOption = !updatedFlag.status;

        const payload = {
            user_id: userData.user_id, global_chat_enabled: updatedOption,
        };

        try {
            const res = await PrivateAdminPanelInstance.post(API_ROUTES.UPDATE_USER_GLOBAL_CHAT_STATUS, payload);

            setGlobalChatOption((prevOptions) => prevOptions.map((option) => {
                return {...option, status: updatedOption};
            }));

            messageApi.success(res.data.message);
        } catch (error) {
            messageApi.error("Failed to update Global Chat status.");
            console.error("Update error:", error);
        }
    };

    const getNewestUserData = async () => {
        if (!userId) return;

        const newestUserData = await fetchSpecificUsersData(PrivateAdminPanelInstance, userId);
        console.log("newestUserData", newestUserData);

        // Default to true (ON) if the property doesn't exist
        // This handles users who don't have the global_chat_enabled field yet
        setGlobalChatOption([{
            id: 1,
            name: `Is Global Chat Enabled for ${newestUserData.username}?`,
            status: newestUserData.global_chat_enabled ?? true,
        },]);
    };

    const handleClosePressed = () => {
        onClosePressed();
    };

    useEffect(() => {
        getNewestUserData();
    }, [userData]);

    if (!isVisible) return null;

    return (<div className="suspend-user-popup user-global-chat-popup">
        {contextHolder}
        <div className="suspend-user-panel">
            {isApiRunning ? (<RebetLoader width={100} height={100}/>) : (<>
                <div className="suspend-user-header">
                    <div className="suspend-user-header-label">
                        Global Chat Toggle
                    </div>
                    <button className="close-button" onClick={handleClosePressed}>
                        <X className="close-icon"/>
                    </button>
                </div>
                <div className="user-global-chat-container">
                    {globalChatOption.map((option) => (<div key={option.id} className="feature-flag-item">
                        <div className="feature-flag-label">{option.name}</div>
                        <div className="user-global-chat-toggle-container">
                    <span className={`user-global-chat-toggle-status ${option.status ? "enabled" : "disabled"}`}>
                      {option.status ? "Yes" : "No"}
                    </span>
                            <ToggleSwitch
                                status={option.status}
                                eventCode={option.id}
                                updateEventCode={handleToggleGlobalChatChange}
                                data={option}
                                onlyUpdate={true}
                            />
                        </div>
                    </div>))}
                </div>
            </>)}
        </div>
    </div>);
};

export default GlobalChatTogglePopup;
